module.exports = __webpack_public_path__ + "static/media/Component 27 – 1 default.eb2c58a4.svg";